import * as React from "react";

const SvgIcnVoiceBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M7 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11A.5.5 0 017 6zm5-3a.5.5 0 01.5.5v17a.5.5 0 11-1 0v-17A.5.5 0 0112 3zm5 5a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7A.5.5 0 0117 8zM9.5 8a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm5 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-10 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm15 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnVoiceBold;
